import r from"../utils.js";import t from"../defaults.js";var o=r,a=t,f=function(r,t,f){var i=this||a;return o.forEach(f,(function(o){r=o.call(i,r,t)})),r};export{f as default};
